import "./ViewTitle.css"

export default function ViewTitle(props: {
    children?: any
}) {
    return <div className={"view-title"}>{props.children}</div>
}